<div class="header">
  <button
    appButton
    name="back"
    location="share-gallery-link"
    [iconButton]="true"
    color="simple-gray"
    height="0"
    (click)="onBack.emit()"
  >
    <app-svg src="/assets/icons/arrow-left.svg"></app-svg>
  </button>
  <h1>Direct Link</h1>
</div>

<app-editable-gallery-url-field
  [item]="gallery()"
  [galleryPermissions]="galleryPermissions()"
  (onEditingPathChange)="isEditingPath.set($event)"
  [showCopyButton]="true"
  [showEditButton]="false"
  #editableUrlField
></app-editable-gallery-url-field>

<div class="access-items" [class.disabled]="isEditingPath()">
  <app-gallery-public-edit-access-item
    [gallery]="gallery()"
    [galleryPermissions]="isSubGallery() ? subGalleryPermissions() : galleryPermissions()"
  ></app-gallery-public-edit-access-item>
  @if (gallery().public_access !== 'no_access') {
    <app-public-password-item
      [gallery]="gallery()"
      [galleryPermissions]="isSubGallery() ? subGalleryPermissions() : galleryPermissions()"
    ></app-public-password-item>
    <app-public-require-identification-item
      [gallery]="gallery()"
      [galleryPermissions]="isSubGallery() ? subGalleryPermissions() : galleryPermissions()"
    ></app-public-require-identification-item>
  }
</div>
